import { z } from "zod";

/**
 * `GET /api/store-connection` 的响应：后台首屏需要的 Tenant 店铺接入信息。
 * `status` 来自本地 Tenant.status；准备中只需要店铺域名，不依赖外部服务。
 */
const storeConnectionSchema = z.object({
  shopDomain: z.string().min(1),
  storeName: z.string().min(1).optional(),
  /** IANA 时区名，后台的时间展示以它为准。 */
  timezone: z.string().min(1).optional(),
});

export const storeConnectionResponseSchema = z.discriminatedUnion("status", [
  storeConnectionSchema.extend({ status: z.literal("preparing") }),
  storeConnectionSchema.extend({
    status: z.literal("ready"),
    storeName: z.string().min(1),
    timezone: z.string().min(1),
  }),
]);

export type StoreConnectionResponse = z.infer<
  typeof storeConnectionResponseSchema
>;

export type StoreConnectionStatus = StoreConnectionResponse["status"];
